import axios from '../axios/axios-auth'

export default class AnalysisTemplateService {

    getTemplate(orgId) {
        return axios.get('/api/v3/analysis-template/organization/' + orgId).then(response => response.data)
    }

    updateTemplate(orgId, params) {
        return axios.post('/api/v3/analysis-template/organization/' + orgId, params).then(response => response.data)
    }

    getUserTemplates() {
        return axios.get('/api/v3/analysis-template/organization/export-template').then(response => response.data)
    }

    exportTemplate(orgId, params) {
        return axios.post('/api/v3/analysis-template/organization/' + orgId + '/export-template', params).then(response => response.data)
    }

}
